<template>

    <scoreLine class="strength_score"  :pose="containerIsVisible ? 'visible' : 'hidden'">
        <div class="icon_score_container">
            <span class="score_laurel"><iconLaurels /></span>
            <span class="score_index" :class="'score' + scoreIndex">{{ scoreIndex }}</span>
        </div>
        <div class="icon_dim_container">

            <IconP1 v-if="dimId == 'p1' " />
            <IconP2 v-if="dimId == 'p2' " />
            <IconP3 v-if="dimId == 'p3' " />
            <IconP4 v-if="dimId == 'p4' " />
            <IconP5 v-if="dimId == 'p5' " />
            <IconP6 v-if="dimId == 'p6' " />
            <IconP7 v-if="dimId == 'p7' " />
            <IconP8 v-if="dimId == 'p8' " />
            <IconP9 v-if="dimId == 'p9' " />
            <IconP10 v-if="dimId == 'p10' " />

        </div>
        <div class="strength_label_score">
            {{ labels[dimId] }}
        </div>
    </scoreLine>

</template>

<script>
    import posed from 'vue-pose';
    import s3StrengthsLabels from '@/locales/s3StrengthsLabels'

    export default {
        name: 'StrengthScore',
        props: ['dimId', 'scoreIndex'],
        components: {
            scoreLine: posed.div({
                visible: {
                    opacity: 1,
                    x: 0,
                    beforeChildren: false,
                    staggerChildren: 150
                },
                hidden: {
                    opacity: 0,
                    x: '-80%',
                    afterChildren: true
                }
            }),
        },
        mounted(){
            setTimeout(() => {
                this.containerIsVisible = true;
            }, (this.scoreIndex + 1) * 100 );
        },
        data(){
            return {
                containerIsVisible: false
            }
        },
        computed: {
            currentEval(){
                return this.$store.state.EvalStore.currentEval
            },
            labels(){
                return s3StrengthsLabels[this.$i18n.locale]
            }
        },
        methods: {

        }
    }
</script>

<style lang="scss" scoped>
.strength_scores{
    .strength_score{
        display: flex;
        align-items: center;
        border-bottom: 1px solid $grey-lighter;
        .icon_score_container{
            width: 128px;
            position: relative;
            text-align: center;
            .score_index{
                font-size: 5rem;
                font-weight: 800;
                z-index: 2;
                position: relative;
                color: $info;
                &.score1{
                    margin-left:8px;
                }
                &.score4{
                    margin-left:-3px;
                }
            }
            .score_laurel{
                position: absolute;
                z-index: 1;
                width: 80px;
                top: -3px;
                margin-left: -27px;
                fill: $primary;
                svg{
                    width: 100px;

                }
            }
        }
        .icon_dim_container{
            width: 64px;
            fill: $grey-light;
            text-align: center;
        }
        .strength_label_score{
            width: 400px;
            font-size: 2rem;
            padding-left: 50px;
        }
    }
}

</style>